var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.base.sp_op_disabled)?_c('div',{staticClass:"OpDisabledBlock is-overlay"}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }